import { createContext, useContext } from "react"

export const OnboardingOverlayContext = createContext(false)

export function useOnboardingOverlayActive(): boolean {
  return useContext(OnboardingOverlayContext)
}
